import { configureStore } from "@reduxjs/toolkit";
import appointmentsReducer from "./slices/appointments";
import timeslotReducer from "./slices/timeslot";
import ordersReducer from "./slices/orders";
import allOrderReducer from "./slices/allOrder";

const store = configureStore({
  reducer: {
    appointments: appointmentsReducer,
    timeslot: timeslotReducer,
    order: ordersReducer,
    allOrder: allOrderReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these field paths in all actions
        ignoredActionsPaths: [
          'payload.createdAt',
          'payload.updatedAt', 
          'payload.paidAt',
          'payload.timestamp',
          'payload.emailSentAt',
          'payload.lastEmailAttemptAt',
        ],
        // Ignore these paths in the state
        ignoredPaths: [
          'order.data.createdAt',
          'order.data.updatedAt',
          'order.data.paidAt',
          'appointments.data.createdAt',
          'appointments.data.updatedAt',
          'appointments.data.emailSentAt',
          'appointments.data.lastEmailAttemptAt',
          'allOrder.data.createdAt',
          'allOrder.data.updatedAt',
          'allOrder.data.paidAt',
        ],
        // Also ignore by action type for bulk array updates
        ignoredActions: [
          'appointments/fetchAppointments/fulfilled',
          'appointments/addAppointment/fulfilled',
          'appointments/updateAppointment/fulfilled',
          'appointments/updateAppointment/pending',
          'appointments/updateAppointment/rejected',
        ],
      },
    }),
});

export default store;
